<template>
  <div>
    <iframe
      ref="flowsIframe"
      @load="onFlowsIframeLoad"
      :src="flows_dashboard"
      v-bind:style="{ width: '1px', minWidth: '100%', marginTop: '-25px' }"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import iFrameResize from "iframe-resizer/js/iframeResizer";
import {
  FLOWS_URL,
  FLOWS_NETWORK_DASHBOARD,
  FLOWS_WAF_TENANT,
} from "@/common/config";
import qs from "qs";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vue Bootstrap", route: "alert" },
      { title: "WAF Flows" },
    ]);
  },
  data() {
    return {
      flows_dashboard:
        FLOWS_URL +
        qs.stringify(
          {
            security_tenant: FLOWS_WAF_TENANT,
            urlParamName: this.$store.getters.currentUser.access_token,
          },
          { addQueryPrefix: true }
        ) +
        "#/view/" +
        FLOWS_NETWORK_DASHBOARD +
        qs.stringify(
          {
            "show-time-filter": true,
            embed: true,
          },
          { addQueryPrefix: true }
        ),
    };
  },
  watch: {
    "$store.state.flows.timeRange"() {
      this.setDashboardTime();
    },
  },
  methods: {
    setDashboardTime: function() {
      const time = this.$store.getters.getFlowsTimeRange;
      if (time && this.$refs.flowsIframe) {
        const contentWindow = this.$refs.flowsIframe.contentWindow;
        if (contentWindow) {
          const message = { actionType: "setDashboardTime", time };
          const uriFilter = "*";
          contentWindow.postMessage(message, uriFilter);
        }
      }
    },
    onFlowsIframeLoad: function() {
      iFrameResize(
        {
          heightCalculationMethod: "taggedElement",
          bodyBackground: "#f2f3f8",
          warningTimeout: 0,
        },
        this.$refs.flowsIframe
      );
      this.setDashboardTime();
    },
  },
};
</script>
